<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">评教服务</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div style="margin-top: 20px;">
                <div class="filter-container">
                    <div style="width: 90%;margin-left: 5%; margin-bottom: 10px;">
                        <el-input v-if="!generalFlag" v-model="queryGenForm.jsxm" placeholder="教师姓名" clearable>
                        </el-input>
                    </div>
                    <div class="formItem text-center">
                        <el-button v-if="generalFlag" @click="createDialogVisible = true" type="primary" plain>
                            <i class="el-icon-edit"></i>&nbsp;参与评教
                        </el-button>
                        <el-button v-if="tjxxFlag && generalFlag && statisticsButtonVisible" @click="openGeneral" type="primary" style="margin-left: 10px;" plain>
                            <i class="el-icon-tickets"></i>&nbsp;统计信息
                        </el-button>

                        <el-button v-if="!generalFlag" @click="handleFilter" type="gray">
                            <i class="el-icon-search"></i>&nbsp;查询
                        </el-button>
                        <el-button v-if="!generalFlag" @click="handleReset" type="gray">
                            <i class="el-icon-refresh"></i>&nbsp;重置
                        </el-button>
                        <el-button v-if="!generalFlag" @click="dialogVisible.queryDialogVisible = true" type="primary">
                            <i class="el-icon-more"></i>&nbsp;更多
                        </el-button>
                        <el-button v-if="!generalFlag" type="danger" @click="backToMain">
                            <i class="el-icon-back"></i>&nbsp;返回
                        </el-button>
                    </div>
                </div>
            </div>

            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%"
                       :visible.sync="dialogVisible.queryDialogVisible">
                <el-row>
                    <el-select v-model="queryGenForm.xnxqbm" placeholder="学年学期" clearable>
                        <el-option v-for="(item, index) in comboData.semester" :key="item.comboValue"
                                   :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-input v-model="queryGenForm.jsbh" placeholder="教师工号" clearable></el-input>
                </el-row>
                <el-row>
                    <el-input v-model="queryGenForm.jsxm" placeholder="教师姓名" clearable></el-input>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="dialogVisible.queryDialogVisible = false">取 消
                    </el-button>
                </div>
            </el-dialog>

            <!-- 总览 start -->
            <div id="listArea" @scroll="handleScroll" v-if="!generalFlag">
                <div v-if="genTableData==null || genTableData.length==0" class="cardTips">暂无数据</div>
                <div class="cardMain" v-for="(item,index) in genTableData" :key="index">
                    <div class="cardText">
                        <p>{{ item.xnxqmc }}</p>
                        <p><label for="">教师工号：</label>{{ item.jsbh }}</p>
                        <p><label for="">教师姓名：</label>{{ item.jsxm }}</p>
                        <p><label for="">总&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分：</label>{{ item.zf }}</p>
                    </div>
                    <div class="cardInput">
                        <el-button type="primary" @click="handleEdit(item.jsxm,item.jsbh,item.xnxqbm)">操作</el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>genTableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="genTitle" width="90%"
                       :visible.sync="dialogVisible.generalInfo">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form label-position="left" width="100%">
                        <el-form-item style="margin-top:10px;" v-if="detailsTable==null || detailsTable.length==0">
                            <div id="listArea" style="height:490px;">
                                <div class="cardTips">暂无数据</div>
                            </div>
                        </el-form-item>

                        <template v-for="(item,index) in detailsTable">
                            <div v-if="index!=0">
                                <el-divider></el-divider>
                            </div>
                            <el-form-item label="评价表名称">
                                {{ item.pjbmc }}
                            </el-form-item>

                            <el-row>
                                <el-col :span='12'>
                                    <el-form-item label="最高分">
                                        {{ item.max }}
                                    </el-form-item>
                                </el-col>
                                <el-col :span='12'>
                                    <el-form-item label="评教人数">
                                        {{ item.pjrs }}
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-form-item label="最低分">
                                {{ item.min }}
                            </el-form-item>

                            <el-row>
                                <el-col :span='12'>
                                    <el-form-item label="平均分">
                                        {{ item.avg }}
                                    </el-form-item>
                                </el-col>

                                <el-col :span='12'>
                                    <el-button type="primary" v-if="item.lx == '03'" size="small"
                                               @click="tkHandleEdit()">
                                        <i class="el-icon-tickets"></i>&nbsp;详情
                                    </el-button>
                                </el-col>
                            </el-row>

                        </template>

                    </el-form>
                </el-scrollbar>
            </el-dialog>
            <!-- 总览 end -->

            <!-- 创建问卷 -->
            <el-dialog id="queryDialog" class="formDialog" title="评教" width="90%" :visible.sync="createDialogVisible"
                       @open="openDialog">
                <el-form ref="queryQueForm" :model="queryQueForm" label-position="left">
                    <el-row>
                        <el-form-item prop="semesterCode" :rules="[{required: true, message: '请选择学年学期'}]">
                            <el-select v-model="queryQueForm.semesterCode" placeholder="学年学期" clearable>
                                <el-option v-for="(item, index) in comboData.semester" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item prop="type" :rules="[{required: true, message: '请选择评教类型'}]">
                            <el-select v-model="queryQueForm.type" :placeholder="typeTips" :disabled="typeDisable"
                                       clearable>
                                <el-option v-for="(item, index) in comboData.type" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                </el-form>

                <div slot="footer" class="dialog-footer text-center">
                    <el-button style="margin-left: 10px;" type="primary" @click="createEvaluate">确 定</el-button>
                    <el-button style="margin-left: 10px;" @click="createDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="listArea" class="mainList" v-if="generalFlag">
                <div v-if="queInfo.length == 0" class="cardTips">没有可查看的评教信息</div>
                <div class="cardMain" v-for="(item,index) in queInfo" :key="index">
                    <div class="cardText">
                        <p>{{ item.xnxqmc }}</p>
                        <p><label for="">评教名称：</label>{{ item.pjbmc }}</p>
                        <p><label for="">评教时间：</label>{{ item.pjsj }}</p>
                    </div>
                    <div class="cardInput">
                        <el-button type="primary" @click="showDetailInfo(item.id, item.lx)">详情</el-button>
                    </div>
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" title="教师教学质量听课评价" :visible.sync="dialogVisible.tkEvaluate"
                       @open="openTk" @close="closeTkEvaluate" :close-on-click-modal=false :show-close=false>
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form ref="tkForm" :model="tkForm" label-width="96px" label-position="left" width="100%">
                        <el-form-item label="学年学期">
                            {{ semesterName }}
                        </el-form-item>
                        <el-form-item label="教师类型" prop="teaType" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="tkForm.teaType" placeholder="请选择" clearable>
                                <el-option v-for="(item, index) in tkComboData.teaType" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="课程类型" prop="courseType" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="tkForm.courseType" placeholder="请选择" clearable>
                                <el-option v-for="(item, index) in tkComboData.courseType" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="教师姓名" prop="teaCode" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="tkForm.teaCode" placeholder="请选择" @change="tkTeaChange" filterable clearable
                                       ref="select"
                                       @hook:mounted="cancalReadOnly"
                                       @visible-change="cancalReadOnly">
                                <el-option v-for="(item, index) in tkComboData.teaName" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="教师所在系部" prop="szxbName">
                            {{ tkForm.szxbName }}
                        </el-form-item>

                        <el-form-item label="课程名称" prop="courseCode" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="tkForm.courseCode" placeholder="请选择" @change="tkCourseChange" clearable>
                                <el-option v-for="(item, index) in tkComboData.course" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="听课班级">
                            {{ tkForm.tkbjName }}
                        </el-form-item>

                        <el-form-item label="听课地点" prop="tkdd" :rules="[{required: true, message: ' '}]" ref="select"
                                      @hook:mounted="cancalReadOnly"
                                      @visible-change="cancalReadOnly">
                            <el-select v-model="tkForm.tkdd" filterable placeholder="请选择" clearable>
                                <el-option v-for="(item, index) in tkComboData.tkdd" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="听课时间" prop="sj" :rules="[{required: true, message: ' '}]">
                            <el-date-picker v-model="tkForm.sj" type="date" placeholder="选择日期"
                                            value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="听课节次" prop="jc" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="tkForm.jc" multiple placeholder="请选择" clearable>
                                <el-option v-for="(item, index) in tkComboData.jc" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="应到学生数" prop="ydxss">
                            {{ tkForm.ydxss }}
                        </el-form-item>

                        <el-form-item label="实到学生数" prop="sdxss">
                            <el-input-number v-model="tkForm.sdxss" :min="0">
                            </el-input-number>
                        </el-form-item>

                        <el-form-item label="迟到学生数" prop="cdxss">
                            <el-input-number v-model="tkForm.cdxss" :min="0">
                            </el-input-number>
                        </el-form-item>

                        <el-form-item label="评分">
                        </el-form-item>

                        <el-form ref="tkFormS" :model="tkForm" label-width="120px" label-position="left" width="100%">
                            <template v-for="(item,index) in pjxData">
                                <el-form-item :label="item.pjxmc" :prop="'dfArr['+index+']'"
                                              :rules="[{required: true, message: ' '}]">
                                    <el-button @click="openTkInfo(index)" size="mini" type="primary">详情</el-button>
                                    <el-input-number size="mini" style="margin-left: 10px;width: 100px;"
                                                     @input="tkChangeDf($event,pjxData[index].bh)"
                                                     v-model="tkForm.dfArr[index]"
                                                     :min="0" :max="parseInt(pjxData[index].qz)">
                                    </el-input-number>
                                </el-form-item>
                            </template>
                        </el-form>

                        <el-form-item label="合计" prop="hj">
                            {{ hjdf }}
                        </el-form-item>

                        <el-form ref="tkForm" :model="tkForm" label-width="96px" label-position="top" width="100%">
                            <el-form-item label="综合评价与建议" prop="zhpjjy">
                                <el-input type="textarea" :rows="15" v-model="tkForm.zhpjjy" maxlength="500"
                                          show-word-limit>
                                </el-input>
                            </el-form-item>
                        </el-form>

                        <el-form-item label="评价人">
                            {{ user.userName }}
                        </el-form-item>

                        <el-form-item label="日期" prop="rq">
                            <el-date-picker v-model="tkForm.rq" type="date" placeholder="选择日期" style="width: 100%;"
                                            value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>

                        <el-form ref="tkForm" :model="tkForm" label-width="96px" label-position="top" width="100%">
                            <el-form-item label="教学过程组织和主要内容" prop="jxgcnr">
                                <el-input type="textarea" :rows="15" v-model="tkForm.jxgcnr" maxlength="500"
                                          show-word-limit>
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </el-form>
                </el-scrollbar>

                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="submit('03')" type="warning">提 交</el-button>
                    <el-button style="margin-left: 10px;" type="danger" @click="back">退 出</el-button>
                </div>
            </el-dialog>

            <!-- 评价项详情 -->
            <div v-if="dialogVisible.tkEvaluateInfo">
                <el-dialog id="mainDialog" class="formDialog" title="详情" :visible.sync="dialogVisible.tkEvaluateInfo"
                           width="90%">
                    <el-scrollbar id="tkMainDialogScroll" ref="mainDialogScroll">
                        <el-form ref="tkForm" :model="tkForm" style="margin-top: -10px;" label-position="left"
                                 width="100%">
                            <el-form-item label="评价项目">
                                {{ pjxData[tkEvaluateInfoIndex].pjxmc }}
                            </el-form-item>

                            <el-form-item label="评价权重">
                                {{ pjxData[tkEvaluateInfoIndex].qz }}
                            </el-form-item>


                            <el-form ref="tkForm" :model="tkForm" label-width="96px" label-position="top" width="100%">
                                <el-form-item label="评价指标">
                                    {{ pjxData[tkEvaluateInfoIndex].pjxnr }}
                                </el-form-item>
                            </el-form>

                            <el-form-item label="评分标准">
                                优:{{ pjxData[tkEvaluateInfoIndex].y }}
                                良:{{ pjxData[tkEvaluateInfoIndex].l }}
                                中:{{ pjxData[tkEvaluateInfoIndex].z }}
                                差:{{ pjxData[tkEvaluateInfoIndex].c }}
                            </el-form-item>
                        </el-form>
                    </el-scrollbar>
                </el-dialog>
            </div>


            <!-- 教师教学质量听课评价 -->
            <el-dialog id="mainDialog" class="formDialog" title="教师教学质量听课评价"
                       :visible.sync="dialogVisible.queryTkEvaluate">
                <el-scrollbar id="tkMainDialogScroll" ref="mainDialogScroll">
                    <el-form label-width="96px" label-position="left" width="100%">
                        <el-select v-if="tkComboOption.tkbbh != ''" v-model="tkComboOption.tkbbh"
                                   @change="showDetailInfo(tkComboOption.tkbbh,'03')">
                            <el-option v-for="(item, index) in tkComboOption.tkCombo" :key="item.comboValue"
                                       :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                        <el-form-item label="教师姓名">
                            <div>
                                {{ tkQueData.basicInfo.jsxm }}
                            </div>
                        </el-form-item>

                        <el-form-item label="学年学期">
                            {{ tkQueData.basicInfo.xnxqmc }}
                        </el-form-item>

                        <el-form-item label="教师类型">
                            {{ tkQueData.basicInfo.jslx }}
                        </el-form-item>

                        <el-form-item label="课程类型">
                            {{ tkQueData.basicInfo.tkkclx }}
                        </el-form-item>

                        <el-form-item label="教师所在系部">
                            {{ tkQueData.basicInfo.jsxbmc }}
                        </el-form-item>

                        <el-form-item label="课程名称">
                            {{ tkQueData.basicInfo.kcmc }}
                        </el-form-item>

                        <el-form-item label="听课班级">
                            {{ tkQueData.basicInfo.tkbjmc }}
                        </el-form-item>

                        <el-form-item label="听课地点">
                            {{ tkQueData.basicInfo.jsmc }}
                        </el-form-item>

                        <el-form-item label="听课时间">
                            {{ tkQueData.basicInfo.tksj }}
                        </el-form-item>

                        <el-form-item label="应到学生数">
                            {{ tkQueData.basicInfo.ydxss }}
                        </el-form-item>

                        <el-form-item label="实到学生数">
                            {{ tkQueData.basicInfo.sdxss }}
                        </el-form-item>

                        <el-form-item label="迟到学生数">
                            {{ tkQueData.basicInfo.cdxss }}
                        </el-form-item>

                        <el-form-item label="得分:">
                        </el-form-item>

                        <el-form label-width="150px" label-position="left" width="100%">
                            <template v-for="(item,index) in tkQueData.pjxInfo">
                                <el-form-item :label="item.pjxmc">
                                    <el-button @click="openQueTkInfo(index)" size="mini" type="primary">详情</el-button>
                                    <span style="margin-left: 20px;">
                                        {{ item.pf }}
                                    </span>

                                </el-form-item>
                            </template>
                        </el-form>

                        <el-form-item label="合计">
                            {{ tkQueData.hjdf }}
                        </el-form-item>

                        <el-form label-position="top" width="100%">
                            <el-form-item label="综合评价与建议">
                                <span v-html="tkQueData.basicInfo.zhpjjy"></span>
                            </el-form-item>
                        </el-form>

                        <el-form-item label="评价人">
                            {{ tkQueData.basicInfo.cjr }}
                        </el-form-item>

                        <el-form-item label="日期">
                            {{ tkQueData.basicInfo.cjsj }}
                        </el-form-item>

                        <el-form label-position="top" width="100%">
                            <el-form-item label="教学过程组织和主要内容">
                                <span v-html="tkQueData.basicInfo.jxnrgc"></span>
                            </el-form-item>
                        </el-form>
                    </el-form>
                </el-scrollbar>
            </el-dialog>

            <!-- 查看  -  评价项详情 -->
            <div v-if="dialogVisible.queryTkEvaluateInfo">
                <el-dialog id="mainDialog" class="formDialog" title="详情"
                           :visible.sync="dialogVisible.queryTkEvaluateInfo" width="90%">
                    <el-scrollbar id="tkMainDialogScroll" ref="mainDialogScroll">
                        <el-form label-position="left" width="100%">
                            <el-form-item label="评价项目">
                                {{ tkQueData.pjxInfo[tkEvaluateInfoIndex].pjxmc }}
                            </el-form-item>

                            <el-form-item label="评价权重">
                                {{ tkQueData.pjxInfo[tkEvaluateInfoIndex].qz }}
                            </el-form-item>

                            <el-form label-position="top" width="100%">
                                <el-form-item label="评价指标">
                                    {{ tkQueData.pjxInfo[tkEvaluateInfoIndex].pjxnr }}
                                </el-form-item>
                            </el-form>

                            <el-form-item label="评分标准">
                                优:{{ tkQueData.pjxInfo[tkEvaluateInfoIndex].y }}
                                良:{{ tkQueData.pjxInfo[tkEvaluateInfoIndex].l }}
                                中:{{ tkQueData.pjxInfo[tkEvaluateInfoIndex].z }}
                                差:{{ tkQueData.pjxInfo[tkEvaluateInfoIndex].c }}
                            </el-form-item>
                        </el-form>
                    </el-scrollbar>
                </el-dialog>
            </div>

            <!-- 学生表 start -->
            <div v-if="dialogVisible.stuEvaluate">
                <el-dialog id="mainDialog" class="formDialog" title="教师教学质量评价（学生）"
                           :visible.sync="dialogVisible.stuEvaluate" :close-on-click-modal=false :show-close=false
                           @close="closeStuXzrDialog()">

                    <el-form ref="pfForm" :model="pfForm" label-width="84px" label-position="left" width="100%">
                        <div
                            style="margin-left: 20px;width: 90%;height: 12vh;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                            <el-form-item label="教师姓名">
                                {{ stuXzrTableData.teaData[pageNum.teaPageNum - 1].teaName }}
                            </el-form-item>
                            <el-tooltip class="item" effect="dark"
                                        :content="parseCourseName(stuXzrTableData.teaData[pageNum.teaPageNum-1].courseName)"
                                        placement="top">
                                <el-form-item label="课程" style="margin-top: -10px;">
                                    {{ parseCourseName(stuXzrTableData.teaData[pageNum.teaPageNum - 1].courseName) }}
                                </el-form-item>
                            </el-tooltip>
                        </div>

                        <el-scrollbar id="pfMainDialogScroll" ref="stuMainDialogScroll">
                            <div ref="stuRef">
                                <div ref="stuWindowRef">
                                    <template v-for="(item,index) in stuXzrTableData.pjxData ">
                                        <div :class='"divider"+index'>
                                            <el-divider></el-divider>
                                        </div>
                                        <el-form ref="pfForm" :model="pfForm" label-width="130px" label-position="left"
                                                 width="100%">
                                            <el-form-item :label="item.xh + '.评价项目(权重)'">
                                                {{ item.pjxmc }}({{ item.qz }})
                                            </el-form-item>
                                        </el-form>

                                        <el-form label-position="top" width="100%">
                                            <el-form-item label="评价标准">
                                                {{ item.pjxnr }}
                                            </el-form-item>
                                        </el-form>

                                        <el-form-item label="评分" :prop="'pfArr['+(pageNum.teaPageNum-1)+']['+index+']'"
                                                      :rules="[{required: true, message: ' '}]">
                                            <el-input-number v-model="pfForm.pfArr[pageNum.teaPageNum-1][index]"
                                                             size="mini" :min="0"
                                                             :max="qzArr[pageNum.teaPageNum-1][index]"
                                                             @input="changePf($event,pageNum.teaPageNum-1,index)">
                                            </el-input-number>
                                        </el-form-item>
                                    </template>
                                </div>
                            </div>
                        </el-scrollbar>
                    </el-form>

                    <div id="pfInputDialogScroll" style="text-align: center;">
                        <div>
                            <el-pagination ref="pagin" small prev-text='上一页' next-text='下一页'
                                           @current-change="getTeaPageNum" layout="prev, slot, next"
                                           :total="parseInt(stuXzrTableData.teaData.length+'0')"
                                           :current-page.sync="pageNum.pageNumColumn">

                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <span>
                                    <span
                                        class="leftSpan">{{
                                            pageNum.teaPageNum
                                        }}</span>/<span>{{ stuXzrTableData.teaData.length }}</span>
                                </span>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </el-pagination>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer text-center">
                        <el-button @click="submit('01')" type="warning">提 交</el-button>
                        <el-button style="margin-left: 10px;" type="danger" @click="back">退 出</el-button>
                    </div>
                </el-dialog>
            </div>
            <!-- 学生表 end -->

            <!-- 查看  -  已完成学生表 start -->
            <div v-if="dialogVisible.queryStuEvaluate">
                <el-dialog id="mainDialog" class="formDialog" title="教师教学质量评价（学生）"
                           :visible.sync="dialogVisible.queryStuEvaluate" width="90%">
                    <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                        <el-form label-width="84px" label-position="left" width="100%">
                            <el-form-item label="教师姓名">
                                {{ stuQueData[pageNum.teaPageNum - 1][0].teaName }}
                            </el-form-item>
                            <el-form-item label="课程">
                                {{ parseCourseName(stuQueData[pageNum.teaPageNum - 1][0].courseName) }}
                            </el-form-item>
                            <el-form-item label="评价项目">
                            </el-form-item>
                            <el-form label-width="150px" label-position="left" width="100%">
                                <template v-for="(item,index) in stuQueData[pageNum.teaPageNum-1]">
                                    <el-form-item :label="item.xh+' '+item.pjxmc+':'">
                                        {{ item.df }}
                                        <el-button style="margin-left: 20px;" @click="openQueStuInfo(index)" size="mini"
                                                   type="primary">详情
                                        </el-button>
                                    </el-form-item>
                                </template>
                            </el-form>
                        </el-form>
                    </el-scrollbar>

                    <div slot="footer" class="dialog-footer text-center">
                        <el-pagination @current-change="getTeaPageNum" small prev-text='上一页' next-text='下一页'
                                       layout="prev, slot, next" :total="parseInt(stuQueData.length+'0')"
                                       :current-page.sync="pageNum.pageNumColumn">
                            <span>
                                <span
                                    class="leftSpan">{{ pageNum.teaPageNum }}</span>/<span>{{
                                    stuQueData.length
                                }}</span>
                            </span>
                        </el-pagination>
                    </div>
                </el-dialog>
            </div>

            <!-- 已完成学生表评价项详情 -->
            <div v-if="dialogVisible.queryStuEvaluateInfo">
                <el-dialog id="mainDialog" class="formDialog" title="详情"
                           :visible.sync="dialogVisible.queryStuEvaluateInfo" width="90%">
                    <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                        <el-form label-width="84px" label-position="left" width="100%">
                            <el-form-item label="序号">
                                {{ stuQueData[pageNum.teaPageNum - 1][stuEvaluateInfoIndex].xh }}
                            </el-form-item>

                            <el-form-item label="评价项目">
                                {{ stuQueData[pageNum.teaPageNum - 1][stuEvaluateInfoIndex].pjxmc }}
                            </el-form-item>

                            <el-form-item label="评价权重">
                                {{ stuQueData[pageNum.teaPageNum - 1][stuEvaluateInfoIndex].qz }}
                            </el-form-item>

                            <el-form label-position="top" width="100%">
                                <el-form-item label="评价标准">
                                    {{ stuQueData[pageNum.teaPageNum - 1][stuEvaluateInfoIndex].pjxnr }}
                                </el-form-item>
                            </el-form>
                        </el-form>
                    </el-scrollbar>
                </el-dialog>
            </div>
            <!-- 查看  -  已完成学生表 end -->

            <!-- 学生表 end -->

            <!-- 系主任表 start -->
            <div v-if="dialogVisible.xzrEvaluate">
                <el-dialog id="mainDialog" class="formDialog" title="教师教学质量评价（系主任）"
                           :visible.sync="dialogVisible.xzrEvaluate" :close-on-click-modal=false :show-close=false
                           @close="closeStuXzrDialog()">

                    <el-form ref="pfForm" :model="pfForm" label-width="84px" label-position="left" width="100%">
                        <div
                            style="margin-left: 20px;width: 90%;height: 12vh;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                            <el-form-item label="教师姓名">
                                {{ stuXzrTableData.teaData[pageNum.teaPageNum - 1].teaName }}
                            </el-form-item>
                            <el-tooltip class="item" effect="dark"
                                        :content="parseCourseName(stuXzrTableData.teaData[pageNum.teaPageNum-1].courseName)"
                                        placement="top">
                                <el-form-item label="课程" style="margin-top: -10px;">
                                    {{ parseCourseName(stuXzrTableData.teaData[pageNum.teaPageNum - 1].courseName) }}
                                </el-form-item>
                            </el-tooltip>
                        </div>

                        <el-scrollbar id="pfMainDialogScroll" ref="stuMainDialogScroll">
                            <div ref="stuRef">
                                <div ref="stuWindowRef">
                                    <template v-for="(item,index) in stuXzrTableData.pjxData ">
                                        <div :class='"divider"+index'>
                                            <el-divider></el-divider>
                                        </div>
                                        <el-form ref="pfForm" :model="pfForm" label-width="130px" label-position="left"
                                                 width="100%">
                                            <el-form-item :label="item.xh + '.评价项目(权重)'">
                                                {{ item.pjxmc }}({{ sfzrQz(pageNum.teaPageNum - 1, index) }})
                                            </el-form-item>
                                        </el-form>

                                        <el-form label-position="top" width="100%">
                                            <el-form-item label="评价标准">
                                                {{ item.pjxnr }}
                                            </el-form-item>
                                        </el-form>

                                        <el-form-item label="评分标准">
                                            {{ sfzrPfbz(pageNum.teaPageNum - 1, index) }}
                                        </el-form-item>

                                        <el-form-item label="评分" :prop="'pfArr['+(pageNum.teaPageNum-1)+']['+index+']'"
                                                      :rules="[{required: true, message: ' '}]">
                                            <el-input-number v-model="pfForm.pfArr[pageNum.teaPageNum-1][index]"
                                                             size="mini" :min="0"
                                                             :max="sfzr(pageNum.teaPageNum-1,index)"
                                                             @input="changePf($event,pageNum.teaPageNum-1,index)">
                                            </el-input-number>
                                        </el-form-item>


                                    </template>
                                </div>
                            </div>
                        </el-scrollbar>
                    </el-form>

                    <div id="pfInputDialogScroll" style="text-align: center;">
                        <div>
                            <el-pagination ref="pagin" small prev-text='上一页' next-text='下一页'
                                           @current-change="getTeaPageNum" layout="prev, slot, next"
                                           :total="parseInt(stuXzrTableData.teaData.length+'0')"
                                           :current-page.sync="pageNum.pageNumColumn">

                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <span>
                                    <span
                                        class="leftSpan">{{
                                            pageNum.teaPageNum
                                        }}</span>/<span>{{ stuXzrTableData.teaData.length }}</span>
                                </span>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </el-pagination>
                        </div>
                    </div>

                    <div slot="footer" class="dialog-footer text-center">
                        <el-button @click="submit('02')" type="warning">提 交</el-button>
                        <el-button style="margin-left: 10px;" type="danger" @click="back">退 出</el-button>
                    </div>
                </el-dialog>
            </div>
            <!-- 系主任表 end -->

            <!-- 查看  -  已完成系主任表 start -->
            <div v-if="dialogVisible.queryXzrEvaluate">
                <el-dialog id="mainDialog" class="formDialog" title="教师教学质量评价（系主任）"
                           :visible.sync="dialogVisible.queryXzrEvaluate" width="90%">


                    <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                        <el-form label-width="84px" label-position="left" width="100%">
                            <el-form-item label="教师姓名">
                                {{ xzrQueData[pageNum.teaPageNum - 1][0].teaName }}
                            </el-form-item>
                            <el-form-item label="课程">
                                {{ parseCourseName(xzrQueData[pageNum.teaPageNum - 1][0].courseName) }}
                            </el-form-item>
                            <el-form-item label="评价项目">
                            </el-form-item>
                            <el-form label-width="150px" label-position="left" width="100%">
                                <template v-for="(item,index) in xzrQueData[pageNum.teaPageNum-1]">
                                    <el-form-item :label="item.xh+' '+item.pjxmc+':'">
                                        <el-button @click="openQueXzrInfo(index)" size="mini" type="primary">详情
                                        </el-button>
                                        <span style="margin-left: 20px;">
                                            {{ item.df }}
                                        </span>

                                    </el-form-item>
                                </template>
                            </el-form>
                        </el-form>
                    </el-scrollbar>


                    <div slot="footer" class="dialog-footer text-center">
                        <el-pagination @current-change="getTeaPageNum" small prev-text='上一页' next-text='下一页'
                                       layout="prev, slot, next" :total="parseInt(xzrQueData.length+'0')"
                                       :current-page.sync="pageNum.pageNumColumn">
                            <span>
                                <span
                                    class="leftSpan">{{ pageNum.teaPageNum }}</span>/<span>{{
                                    xzrQueData.length
                                }}</span>
                            </span>
                        </el-pagination>
                    </div>
                </el-dialog>
            </div>
            <!-- 已完成学生表评价项详情 -->
            <div v-if="dialogVisible.queryXzrEvaluateInfo">
                <el-dialog id="mainDialog" class="formDialog" title="详情"
                           :visible.sync="dialogVisible.queryXzrEvaluateInfo" width="90%">
                    <el-scrollbar id="xzrMainDialogScroll" ref="mainDialogScroll">
                        <el-form label-width="84px" label-position="left" width="100%">
                            <el-form-item label="序号">
                                {{ xzrQueData[pageNum.teaPageNum - 1][xzrEvaluateInfoIndex].xh }}
                            </el-form-item>

                            <el-form-item label="评价项目">
                                {{ xzrQueData[pageNum.teaPageNum - 1][xzrEvaluateInfoIndex].pjxmc }}
                            </el-form-item>

                            <el-form-item label="评价权重">
                                {{ xzrQueData[pageNum.teaPageNum - 1][xzrEvaluateInfoIndex].qz }}
                            </el-form-item>

                            <el-form label-position="top" width="100%">
                                <el-form-item label="评价标准">
                                    {{ xzrQueData[pageNum.teaPageNum - 1][xzrEvaluateInfoIndex].pjxnr }}
                                </el-form-item>
                            </el-form>

                            <el-form label-position="top" width="100%">
                                <el-form-item label="评分标准">
                                    <div v-html="xzrQueData[pageNum.teaPageNum-1][xzrEvaluateInfoIndex].pfbzsm"/>
                                </el-form-item>
                            </el-form>
                        </el-form>
                    </el-scrollbar>
                </el-dialog>
            </div>
            <!-- 查看  -  已完成系主任表 start -->

            <el-dialog id="mainDialog" class="formDialog" :visible.sync="dialogVisible.tkjlEvaluate"
                       @open="openTkjl" @closed="closeTkjl" :close-on-click-modal=false :show-close=false>
                <template slot="title">
                    <span style="color: #303133;font-weight: bold;font-size: 18px">{{tkjlTitle}}</span>
                    <button
                        style="background-color: #409eff;border: none;width: 70px;height: 30px;margin-left: 20px" @click="openCkzb">
                        <span style="font-size: 12px;color: #FFFFFF">参考指标</span></button>
                </template>
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form ref="tkjlForm" :model="tkjlForm" label-width="96px" label-position="left" width="100%">
                        <el-form-item label="学年学期">
                            {{ semesterName }}
                        </el-form-item>

                        <el-form-item label="授课教师" prop="teaCode" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="tkjlForm.teaCode" placeholder="请选择" style="width: 100%;"
                                       @change="tkjlTeaChange" filterable clearable>
                                <el-option v-for="(item, index) in tkjlComboOption.tea" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="教师所在系部">
                            {{ tkjlForm.deptName }}
                        </el-form-item>

                        <el-form-item label="授课班级">
                            {{ tkjlForm.className }}
                        </el-form-item>

                        <el-form-item label="授课地点" prop="site" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="tkjlForm.site" filterable placeholder="请选择" style="width: 100%;"
                                       clearable>
                                <el-option v-for="(item, index) in tkjlComboOption.site" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="课程名称" prop="courseCode" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="tkjlForm.courseCode" placeholder="请选择" style="width: 100%;"
                                       @change="tkjlCourseChange" clearable>
                                <el-option v-for="(item, index) in tkjlComboOption.course" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                    <div slot>{{ item.className + " - (" + item.comboName + ")" }}</div>
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="课题" prop="kt" :rules="[{required: true, message: ' '}]">
                            <el-input v-model="tkjlForm.kt" maxlength="500"/>
                        </el-form-item>

                        <el-form-item label="听课日期" prop="date" :rules="[{required: true, message: ' '}]">
                            <el-date-picker v-model="tkjlForm.date" type="date" placeholder="选择日期" style="width: 100%;"
                                            value-format="yyyy-MM-dd"/>
                        </el-form-item>

                        <el-form-item label="听课节次" prop="time" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="tkjlForm.time" multiple :multiple-limit="3" placeholder="请选择" clearable
                                       style="width: 100%">
                                <el-option v-for="(item, index) in tkjlComboOption.time" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="按时上课（√）" prop="assk" label-width="135px">
                            <el-checkbox v-model="tkjlForm.assk"/>
                        </el-form-item>

                        <el-form-item label="迟到（分钟）" prop="cd" :rules="[{required: true, message: ' '}]"
                                      label-width="135px">
                            <el-input-number v-model="tkjlForm.cd" style="width: 100%;" :min="0"/>
                        </el-form-item>

                        <el-form-item label="提前下课（分钟）" prop="tqxk" :rules="[{required: true, message: ' '}]"
                                      label-width="135px">
                            <el-input-number v-model="tkjlForm.tqxk" style="width: 100%;" :min="0"/>
                        </el-form-item>

                        <el-form-item label="应到人数" label-width="135px">
                            {{ tkjlForm.ydxss }}
                        </el-form-item>

                        <el-form-item label="实到人数" prop="sdrs" :rules="[{required: true, message: ' '}]"
                                      label-width="135px">
                            <el-input-number v-model="tkjlForm.sdrs" style="width: 100%;" :min="0"/>
                        </el-form-item>

                        <el-form-item label="迟到人数" prop="cdrs" :rules="[{required: true, message: ' '}]"
                                      label-width="135px">
                            <el-input-number v-model="tkjlForm.cdrs" style="width: 100%;" :min="0"/>
                        </el-form-item>

                        <el-form-item label="迟到最长（分钟）" prop="cdrs" :rules="[{required: true, message: ' '}]"
                                      label-width="135px">
                            <el-input-number v-model="tkjlForm.cdzc" style="width: 100%;" :min="0"/>
                        </el-form-item>

                        <el-form-item label="早退人数" prop="ztrs" :rules="[{required: true, message: ' '}]"
                                      label-width="135px">
                            <el-input-number v-model="tkjlForm.ztrs" style="width: 100%;" :min="0"/>
                        </el-form-item>

                        <el-form-item label="授课过程记录" prop="skgcjl" :rules="[{required: true, message: ' '}]"
                                      label-width="300px"/>
                        <el-form-item label="" prop="skgcjl" :rules="[{required: true, message: ' '}]" label-width="0">
                            <el-input type="textarea" :rows="15" v-model="tkjlForm.skgcjl" maxlength="500"
                                      show-word-limit/>
                        </el-form-item>

                        <el-form-item label="教学建议" prop="jxjy" :rules="[{required: true, message: ' '}]" label-width="300px"/>
                        <el-form-item label="" prop="jxjy" :rules="[{required: true, message: ' '}]" label-width="0">
                            <el-input type="textarea" :rows="15" v-model="tkjlForm.jxjy" maxlength="500"
                                      show-word-limit/>
                        </el-form-item>

                        <el-form-item label="评价等级" prop="pjdj" :rules="[{required: true, message: ' '}]" label-width="300px"/>
                        <el-form-item label="" prop="pjdj" :rules="[{required: true, message: ' '}]" label-width="0">
                            <el-select v-model="tkjlForm.pjdj" placeholder="请选择" clearable style="width: 100%">
                                <el-option v-for="(item, index) in tkjlComboOption.pjdj" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-form>
                </el-scrollbar>

                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="submit('tkjl')" type="warning">提 交</el-button>
                    <el-button style="margin-left: 10px;" type="danger" @click="back">退 出</el-button>
                </div>
            </el-dialog>

            <el-dialog id="mainDialog" class="formDialog" :title="ckzbTitle" :visible.sync="dialogVisible.ckzb">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form label-position="top" width="100%">

                        <el-form-item label="目标与学情">
                            <span v-if="tkjlType === 'gg'">1.符合新时代对技术技能人才培养新要求，落实教育部颁布的公共基础课程教学标准有关要求，紧扣学校专业人才培养方案和课程教学安排，夯实学生科学文化基础，着力培养学生人文素养、职业素养、信息素养，培养学生工匠精神、科学精神、创新精神和终身学习能力。<br>2.教学目标表述明确、相互关联，重点突出、可评可测。<br>3.客观分析学生知识基础、认知能力、学习特点、专业特性等，详实反映学生整体情况与个体差异，准确预判教学难点。</span>
                            <span v-else>1.适应新时代对高素质技术技能人才培养的新要求，符合教育部发布的专业教学标准、实训教学条件建设标准、岗位实习标准等有关要求，涉及职业技能等级证书的课程教学内容，还应对接有关职业技能等级标准。紧扣学校专业人才培养方案和课程标准，夯实学生专业基础和专业能力，培育学生职业道德、职业能力、信息素养、创新能力、工程思维，培养学生科学精神、工匠精神和终身学习能力。<br>2.教学目标表述明确、相互关联，重点突出、可评可测。<br>3.客观分析学生的知识和技能基础、认知和实践能力、学习特点等，详实反映学生整体情况与个体差异，准确预判教学难点。</span>
                        </el-form-item>

                        <el-form-item label="内容与策略">
                            <span v-if="tkjlType === 'gg'">1.思政课程按照“八个相统一”要求扎实推进创优建设；其他课程注重落实课程思政要求，结合课程特点挖掘思政元素，有机融入课程教学，达到润物无声的育人效果。<br>2.教学内容落实公共基础课程课标，突出思想性、科学性、基础性、职业性和时代性，有效支撑教学目标的实现，内容选择科学严谨、容量适度，安排合理、衔接有序、结构清晰，符合层次定位。<br>3.教材选用、使用符合《职业院校教材管理办法》等文件规定和要求，配套提供丰富、优质学习资源；教案完整、规范、简明、真实。<br>4.教学设计科学合理，教学过程系统优化，流程环节构思得当，技术应用预想合理，方法手段设计恰当，评价考核科学有效。</span>
                            <span v-else>1.结合课程特点、思维方法和价值理念，挖掘提炼专业知识体系中所蕴含的思想价值和精神内涵，有机融入课程教学，达到润物无声的育人效果。<br>2.教学内容落实课程标准，对接新产业、新业态、新模式、新职业，促进书证融通，有效支撑教学目标的实现，内容选择科学严谨、容量适度，安排合理、衔接有序、结构清晰，符合层次定位；实习实训内容与专业课程教学内容匹配，强化核心技术技能训练。<br>3.教材选用符合《职业院校教材管理办法》等文件规定和要求，配套提供丰富、优质学习资源，鼓励使用新型活页式、工作手册式教材；教案完整、规范、简明、真实。<br>4.教学设计合理，教学过程系统优化，流程环节构思得当，技术应用预想合理，方法手段设计恰当，评价考核科学有效，突出项目式、任务式、案例式、情境式等教学方式。</span>
                        </el-form-item>

                        <el-form-item label="实施与成效">
                            <span v-if="tkjlType === 'gg'">1.教育思想和教学理念先进，遵循学生认知规律，反映日常教学实际。<br>2.按照授课计划实施教学，关注重点、难点的解决，能够针对学习反馈及时调整教学，突出学生中心，实行因材施教。<br>3.教学环境真实，满足教学需要，教学活动开展有序，教学互动深入有效，教学气氛生动活泼，学生学有所得。<br>4.关注教与学行为数据采集，针对目标要求开展考核与评价。<br>5.创新教学方式方法，合理运用前沿信息技术、数字化教学资源、设施设备改造传统教学，提升学习效果、提高教学与管理成效。</span>
                            <span v-else>1.教育思想和教学理念先进，落实德技并修、工学结合，遵循职业教育规律、学生认知规律和技术技能人才成长规律，反映日常教学实际。<br>2.按照授课计划实施教学，关注技术技能教学重点、难点的解决，能够针对学习和实践反馈及时调整教学，突出学生中心，落实理实一体化，强调知行合一，实行因材施教；针对不同生源特点，体现灵活的教学组织形式。<br>3.教学环境真实，能够满足教学需要，教学活动安全有序，教学互动深入有效，教学气氛生动活泼，学生乐学、学会。<br>4.关注教与学行为数据采集，针对目标要求开展教学与实践的考核与评价。<br>5.创新教学方式方法，合理运用前沿信息技术、数字化资源、设施设备改造传统教学与实习实训，提升学习效果，提高教学与管理效能。</span>
                        </el-form-item>

                        <el-form-item label="教学素养">
                            <span v-if="tkjlType === 'gg'">1.展现新时代职业院校教师良好的师德师风、教学能力和信息素养。<br>2.教师课堂教学态度认真、严谨规范、表述清晰、亲和力强、仪态自然。<br>3.教学研究深入，学术功底扎实。</span>
                            <span v-else>1.展现新时代职业院校教师良好的师德师风、教学能力、实践能力和信息素养。<br>2.课堂教学态度认真、严谨规范、表述清晰、亲和力强、仪态自然。<br>3.实训教学讲解和操作配合恰当，规范娴熟、示范有效，符合职业岗位要求，展现良好“双师”素养。<br>4.教学研究深入，学术功底扎实。</span>
                        </el-form-item>

                        <el-form-item label="特色创新">
                            <span v-if="tkjlType === 'gg'">1.在落实立德树人、文化素养提升、课程思政建设等方面有行之有效的做法，能够调动学生全面深度参与，给学生深刻的学习体验。<br>2.在落实国家教学标准、推进“三教”改革、运用信息技术等方面有特色、有创新。<br>3.具有较大借鉴和推广价值。</span>
                            <span v-else>1.在落实立德树人、德技并修，课程思政，工学结合、知行合一等方面有行之有效的做法，能够调动学生全面深度参与，给学生深刻的学习体验，促进学生职业综合素质和行动能力的明显提升。<br>2.在落实国家教学标准、推进“三教”改革、运用信息技术等方面有特色、有创新。<br>3.具有较大借鉴和推广价值。</span>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>

                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="dialogVisible.ckzb = false">关 闭</el-button>
                </div>
            </el-dialog>


            <el-dialog id="mainDialog" class="formDialog" :visible.sync="dialogVisible.queryTkjlEvaluate">
                <template slot="title">
                    <span style="color: #303133;font-weight: bold;font-size: 18px">{{tkjlTitle}}</span>
                    <button
                        style="background-color: #409eff;border: none;width: 70px;height: 30px;margin-left: 20px" @click="openCkzb">
                        <span style="font-size: 12px;color: #FFFFFF">参考指标</span></button>
                </template>
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form label-width="96px" label-position="left" width="100%">
                        <el-form-item label="学年学期">
                            {{ tkjlQueData.xnxqmc }}
                        </el-form-item>

                        <el-form-item label="授课教师">
                            {{ tkjlQueData.jsxm }}
                        </el-form-item>

                        <el-form-item label="教师所在系部">
                            {{ tkjlQueData.jsxbmc }}
                        </el-form-item>

                        <el-form-item label="授课班级">
                            {{ tkjlQueData.tkbjmc }}
                        </el-form-item>

                        <el-form-item label="授课地点">
                            {{ tkjlQueData.jsmc }}
                        </el-form-item>

                        <el-form-item label="课程名称">
                            {{ tkjlQueData.kcmc }}
                        </el-form-item>

                        <el-form-item label="课题">
                            {{ tkjlQueData.kt }}
                        </el-form-item>

                        <el-form-item label="听课日期">
                            {{ tkjlQueData.tkrq }}
                        </el-form-item>

                        <el-form-item label="听课节次">
                            {{ tkjlQueData.tkjc }}
                        </el-form-item>

                        <el-form-item label="按时上课（√）" label-width="135px">
                            {{ tkjlQueData.sfassk }}
                        </el-form-item>

                        <el-form-item label="迟到（分钟）" label-width="135px">
                            {{ tkjlQueData.skcdsj }}
                        </el-form-item>

                        <el-form-item label="提前下课（分钟）" label-width="135px">
                            {{ tkjlQueData.tqxksj }}
                        </el-form-item>

                        <el-form-item label="应到人数" label-width="135px">
                            {{ tkjlQueData.ydxss }}
                        </el-form-item>

                        <el-form-item label="实到人数" label-width="135px">
                            {{ tkjlQueData.sdxss }}
                        </el-form-item>

                        <el-form-item label="迟到人数" label-width="135px">
                            {{ tkjlQueData.cdxss }}
                        </el-form-item>

                        <el-form-item label="迟到最长（分钟）" label-width="135px">
                            {{ tkjlQueData.cdzcsj }}
                        </el-form-item>

                        <el-form-item label="早退人数" label-width="135px">
                            {{ tkjlQueData.ztxss }}
                        </el-form-item>

                        <el-form-item label="授课过程记录" label-width="300px"/>
                        <el-form-item label="" label-width="0">
                            <span v-html="tkjlQueData.jxnrgc"></span>
                        </el-form-item>

                        <el-form-item label="教学建议" label-width="300px"/>
                        <el-form-item label="" label-width="0">
                            <span v-html="tkjlQueData.zhpjjy"></span>
                        </el-form-item>

                        <el-form-item label="评价等级" label-width="300px"/>
                        <el-form-item label="" label-width="0">
                            {{ tkjlQueData.pjdj }}
                        </el-form-item>

                    </el-form>
                </el-scrollbar>

            </el-dialog>


        </div>

    </div>
</template>
<script>
import {confirmMsg, showNotify} from "utils/message";
import {globalConfig} from "static/config"

export default {
    components: {},
    data() {
        return {
            statisticsButtonVisible: false,
            typeTips: null,
            typeDisable: false,
            laterSub: false,
            generalFlag: true,
            dialogVisible: {
                tkEvaluate: false,
                tkEvaluateInfo: false,
                queryTkEvaluate: false,
                queryTkEvaluateInfo: false,
                stuEvaluate: false,
                queryStuEvaluate: false,
                queryStuEvaluateInfo: false,
                xzrEvaluate: false,
                queryXzrEvaluate: false,
                queryXzrEvaluateInfo: false,
                generalDialogVisible: false,
                queryDialogVisible: false,
                generalInfo: false,
                tkjlEvaluate: false,
                queryTkjlEvaluate: false,
                ckzb:false
            },
            createDialogVisible: false,
            semesterName: "",
            //查询问卷
            queryQueForm: {
                semesterCode: "",
                type: ""
            },
            comboData: {
                semester: [],
                type: []
            },
            //登录人信息
            user: {
                userCode: "",
                userName: "",
                userRoles: [],
            },
            //问卷信息列表
            queInfo: [],
            /** 听课表 start */
            //下拉框:
            tkComboData: {
                //教师姓名
                teaName: [],
                //课程名称
                course: [],
                //听课班级
                tkbj: [],
                //听课地点
                tkdd: [],
                //节次
                jc: [],
                //教师类型
                teaType: [{
                    "comboValue": "专任教师",
                    "comboName": "专任教师"
                },
                    {
                        "comboValue": "兼职教师",
                        "comboName": "兼职教师"
                    },
                    {
                        "comboValue": "外聘教师",
                        "comboName": "外聘教师"
                    },
                ],
                //课程类型
                courseType: [{
                    "comboValue": "理论",
                    "comboName": "理论"
                },
                    {
                        "comboValue": "实践",
                        "comboName": "实践"
                    },
                    {
                        "comboValue": "理实一体",
                        "comboName": "理实一体"
                    },
                ],
            },
            tkForm: {
                semester: '',
                teaType: '',
                teaCode: '',
                teaName: '',
                courseName: '',
                courseCode: '',
                courseType: '',
                szxbCode: '',
                szxbName: '',
                tkbjName: '',
                tkbjCode: '',
                tkdd: '',
                tksj: '',
                ydxss: '',
                sdxss: '',
                cdxss: '',
                zhpjjy: '',
                jxgcnr: '',
                df: new Map(),
                dfArr: [],
                rq: this.rqFormat(new Date()),
                sj: this.format(new Date()),
                jc: [],
            },
            //得分数组
            tkArr: {
                dfArr: [],
            },
            //合计得分
            hjdf: '',
            pjxData: [],
            tkEvaluateInfoIndex: 0,
            tkRules: [{
                required: true,
                message: "请选择原课程",
                trigger: ["blur", "change"],
            }],
            /** 听课表 end */

            /** 听课表 end */
            /*查看已完成 - 教师教学质量听课评价表 start*/
            tkQueData: {
                basicInfo: [],
                pjxInfo: [],
                hjdf: 0
            },
            /*查看已完成 - 教师教学质量听课评价表 end*/
            /** 听课表 end */


            /** 学生表 start */
            stuXzrTableData: {
                class: [],
                pjxData: [],
                teaData: []
            },


            /** 学生表 end */

            /** 系主任表 start */
            xzrQueData: [],
            /** 系主任表 end */

            //评分
            pfForm: {
                pfArr: [],
            },
            //权重
            qzArr: [],
            //提交
            subArr: [],
            //存储得分
            dfArr: [],


            /** 查看 已完成学生表 start */
            stuQueData: [],
            stuEvaluateInfoIndex: 0,
            /** 查看 已完成学生表 end */

            /** 总览 start */
            queryGenForm: {
                pageNum: 1,
                rowNum: 10,
                xnxqbm: '',
                jsbh: '',
                jsxm: ''
            },
            genTableData: [],
            total: null,
            tableLoading: true,
            currentPage: 1,
            limit: 10,
            paramMap: {
                jsbh: '',
                xnxqbm: ''
            },
            detailsTable: [],
            genTitle: '',
            tkComboOption: {
                tkCombo: [],
                tkbbh: ''
            },
            /** 总览 end */

            xzrEvaluateInfoIndex: 0,

            pageNum: {
                teaPageNum: 1,
                pjxPageNum: 1,
                pageNumRow: 1,
                pageNumColumn: 1
            },

            /** 听课记录 start */
            tkjlForm: {
                semesterCode: '',
                teaCode: '',
                deptName: '',
                deptCode: '',
                date: '',
                time: [],
                className: '',
                classCode: '',
                courseCode: '',
                courseName: '',
                ydxss: '',
                assk: true,
                cd: 0,
                tqxk: 0,
                sdrs: 0,
                cdrs: 0,
                cdzc: 0,
                ztrs: 0,
                kt: '',
                skgcjl: '',
                jxjy: '',
                pjdj: '',
                site:''
            },
            tkjlComboOption: {
                tea: [],
                course: [],
                time: [],
                site: [],
                pjdj: [
                    {'comboValue': 'A', 'comboName': '优秀'},
                    {'comboValue': 'B', 'comboName': '良好'},
                    {'comboValue': 'C', 'comboName': '中等'},
                    {'comboValue': 'D', 'comboName': '合格'},
                    {'comboValue': 'E', 'comboName': '不合格'},
                ]
            },
            tkjlType: '',
            tkjlTitle: '',
            ckzbTitle:'',
            tkjlQueData:[],
            /** 听课记录 end */
            tjxxFlag:false

        };
    },
    created() {
    },
    mounted() {
        this.userInfo();
    },
    methods: {
        parseCourseName(str){
            let split = str.split("、");
            let set = new Set();
            split.forEach(item=>{
                set.add(item)
            })
            str = "";
            set.forEach(item=>{
                str += item + "、"
            })
            return str.substring(0, str.length - 1);
        },
        cancalReadOnly(value) {
            this.$nextTick(() => {
                if (!value) {
                    const { select } = this.$refs;
                    const input = select.$el.querySelector(".el-input__inner");
                    input.removeAttribute("readonly");
                    // this.$refs.select.blur();  根据tip自行判断是否添加
                }
            });
        },

        /** 听课记录 start */
        openCkzb(){
            this.dialogVisible.ckzb = true
        },
        tkjlTeaChange() {
            this.tkjlComboOption.course = [];
            this.tkjlForm.courseName = "";
            const paramMap = {
                'teaCode': this.tkjlForm.teaCode,
                'semesterCode': this.queryQueForm.semesterCode,
            }
            if (this.tkjlForm.teaCode !== "") {
                if (this.tkjlType === 'gg') {
                    this.ggCourseCombo(paramMap);
                } else if (this.tkjlType === 'zy') {
                    this.zyCourseCombo(paramMap);
                }

                this.tkSzxb(paramMap)
            }
        },
        ggCourseCombo(paramMap) {
            this.$api.evaluateManage.questionnaireServer.tkGgCourseCombo({
                data: paramMap
            })
                .then((res) => {
                    this.tkjlComboOption.course = res.data.data;
                }).catch((err) => {
                console.log(err);
            });
        },
        zyCourseCombo(paramMap) {
            this.$api.evaluateManage.questionnaireServer.tkZyCourseCombo({
                data: paramMap
            })
                .then((res) => {
                    this.tkjlComboOption.course = res.data.data;
                }).catch((err) => {
                console.log(err);
            });
        },
        openTkjl() {
            this.tkTeaCombo();
            this.tkTkddCombo();
            this.tkJcInfo();
            this.getSemesterName();
        },
        /** 听课记录 end */
        showHomePage() {
            this.$router.push('/m/home');
        },
        openDialog() {
            if (this.$refs['queryQueForm'] !== undefined) {
                this.$refs['queryQueForm'].clearValidate();
                this.$refs['queryQueForm'].resetFields();
            }
            this.queryQueForm.semesterCode = null;
            this.queryQueForm.type = null;
        },
        userInfo() {
            this.$api.system.basic.userInfo({}).then((res) => {
                this.user.userName = res.data.data.name;
                this.user.userCode = res.data.data.phone;

                const userInfo = res.data.data;
                for (let roleCode in userInfo.roles) {
                    this.user.userRoles.push(roleCode);
                    if (roleCode === globalConfig.auth.admin || roleCode === globalConfig.auth.dd) {
                        this.tjxxFlag = true
                    }
                    if (roleCode !== globalConfig.auth.xs) {
                        this.statisticsButtonVisible = true;
                    }
                }

                this.initCombo();
                this.finishedQue();
            }).catch((err) => {
                console.log(err);
            });
        },
        //已完成问卷
        finishedQue() {
            this.$api.evaluateManage.questionnaireServer.finishedQue({
                data: this.user.userCode
            }).then((res) => {
                this.queInfo = res.data.data;
            }).catch((err) => {
                showNotify('错误', err, 'error', 3000);
            });
        },
        //下拉框数据
        initCombo() {
            this.$api.common.comboOption.semester({}).then((res) => {
                this.comboData.semester = res.data.data.comboData
            }).catch((err) => {
                showNotify('错误', err, 'error', 3000);
            });
            let s = this.user.userRoles.toString()
            this.$api.evaluateManage.questionnaireServer.type({
                data: s
            }).then((res) => {
                this.comboData.type = res.data.data.comboData;
                if (this.comboData.type.length === 0) {
                    this.typeTips = '暂无可以参与的评教类型';
                    this.typeDisable = true;
                } else {
                    this.typeTips = '请选择评教类型';
                    this.typeDisable = false;
                }
            }).catch((err) => {
                showNotify('错误', err, 'error', 3000);
            });
        },
        //创建评教
        createEvaluate() {
            //听课表可重复做
            this.$refs["queryQueForm"].validate((valid) => {
                if (valid) {
                    if (this.queryQueForm.type === "01" || this.queryQueForm.type === "02") {
                        let formData = new FormData();
                        formData.append('type', this.queryQueForm.type);
                        formData.append('semesterCode', this.queryQueForm.semesterCode)
                        formData.append('userCode', this.user.userCode)
                        this.$api.evaluateManage.questionnaireServer.createEvaluate({
                            data: formData
                        })
                            .then((res) => {
                                if (res.data.data == "veto") {
                                    this.$alert("当前学期已完成该评教", "提示", {
                                        confirmButtonText: "确定",
                                        customClass: 'el-message-box-mobile',
                                    });
                                } else {
                                    if (this.queryQueForm.type == "01") {
                                        this.querystuXzrTableData()
                                    }

                                    if (this.queryQueForm.type == "02") {
                                        this.queryXzrTableData()
                                    }
                                }
                            }).catch((err) => {
                            console.log(err);
                        });
                    } else {
                        this.createDialogVisible = false;

                        if (this.queryQueForm.type === "03") {
                            this.dialogVisible.tkEvaluate = true;
                        } else if (this.queryQueForm.type === "04") {
                            this.dialogVisible.tkjlEvaluate = true
                            this.tkjlType = 'gg'
                            this.tkjlTitle = '听课记录表（公共基础）'
                            this.ckzbTitle = '公共基础课程参考指标'
                        } else if (this.queryQueForm.type === "05") {
                            this.dialogVisible.tkjlEvaluate = true
                            this.tkjlType = 'zy'
                            this.tkjlTitle = '听课记录表（专业课程）'
                            this.ckzbTitle = '专业课程参考指标'
                        }
                        this.createDialogVisible = false;

                    }
                } else {
                    return false;
                }
            });
        },

        /** 听课表 start */
        //打开听课表
        openTk() {
            this.tkTeaCombo();
            this.tkTkddCombo();
            this.tkJcInfo();
            this.getPjxData();
            this.getSemesterName();
        },
        //教师下拉框
        tkTeaCombo() {
            this.$api.evaluateManage.questionnaireServer.tkTeaCombo({
                data:this.queryQueForm.semesterCode
            })
                .then((res) => {
                    this.tkComboData.teaName = res.data.data;
                    this.tkjlComboOption.tea = res.data.data;
                }).catch((err) => {
                console.log(err);
            });
        },
        //听课地点下拉框
        tkTkddCombo() {
            this.$api.evaluateManage.questionnaireServer.tkTkddCombo({})
                .then((res) => {
                    this.tkComboData.tkdd = res.data.data
                    this.tkjlComboOption.site = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },
        //获得节次信息
        tkJcInfo() {
            this.tkForm.semester = this.queryQueForm.semesterCode
            this.$api.evaluateManage.questionnaireServer.tkJcInfo({
                data: this.tkForm.semester
            })
                .then((res) => {
                    this.tkComboData.jc = res.data.data
                    this.tkjlComboOption.time = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },
        //获取评价项内容
        getPjxData() {
            this.$api.evaluateManage.questionnaireServer.pjxData({
                data: this.queryQueForm.type
            })
                .then((res) => {
                    var map = new Map();
                    this.pjxData = res.data.data
                    for (var i = 0; i < this.pjxData.length; i++) {
                        this.tkForm.df.set(this.pjxData[i].bh, "");
                        this.tkArr.dfArr.push(this.pjxData[i].bh)
                    }
                    for (var i = 0; i < this.pjxData.length; i++) {
                        this.pjxData[i].y = this.pjxData[i].y.replace("<br />|<br />", "~")
                        this.pjxData[i].l = this.pjxData[i].l.replace("<br />|<br />", "~")
                        this.pjxData[i].z = this.pjxData[i].z.replace("<br />|<br />", "~")
                        this.pjxData[i].c = this.pjxData[i].c.replace("<br />", "")
                    }

                }).catch((err) => {
                console.log(err);
            });
        },
        //更换教师
        tkTeaChange() {
            this.tkComboData.course = [];
            this.tkForm.courseName = "";
            this.tkForm.courseCode = "";
            this.tkForm.tkbjCode = "";
            this.tkForm.tkbjName = "";
            this.tkForm.szxbName = "";
            this.tkForm.szxbCode = "";
            const paramMap = {
                'teaCode': this.tkForm.teaCode,
                // 'teaCode': '109011',
                'semesterCode': this.queryQueForm.semesterCode,
            }
            if (this.tkForm.teaCode != "") {
                this.tkCourseCombo(paramMap);
                this.tkSzxb(paramMap)
            }
        },
        tkjlCourseChange() {
            this.tkjlComboOption.course.forEach(item => {
                if (item.comboValue === this.tkjlForm.courseCode) {
                    this.tkjlForm.className = item.className;
                    this.tkjlForm.classCode = item.classCode;
                    this.tkjlChangeTkbj()
                    this.loadClassSite()
                    return;
                }
            })
        },
        loadClassSite(){
            this.$api.evaluateManage.questionnaireServer.loadClassSite({
                data: this.tkjlForm.classCode
            })
                .then((res) => {
                    this.tkjlForm.site = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },
        //更换课程
        tkCourseChange() {
            this.tkComboData.course.forEach(item => {
                if (item.comboValue === this.tkForm.courseCode) {
                    this.tkForm.tkbjName = item.className;
                    this.tkForm.tkbjCode = item.classCode;
                    this.tkChangeTkbj()
                    return;
                }
            })
        },
        //更换班级
        tkjlChangeTkbj() {
            const paramMap = {
                'tkbjCode': this.tkjlForm.classCode,
                'semesterCode': this.queryQueForm.semesterCode,
                'skjhmxbh': this.tkjlForm.courseCode
            }
            this.$api.evaluateManage.questionnaireServer.tkYdxss({
                data: paramMap
            })
                .then((res) => {
                    this.tkjlForm.ydxss = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },
        tkChangeTkbj() {
            const paramMap = {
                'tkbjCode': this.tkForm.tkbjCode,
                'semesterCode': this.queryQueForm.semesterCode,
                'skjhmxbh': this.tkForm.courseCode
            }
            this.$api.evaluateManage.questionnaireServer.tkYdxss({
                data: paramMap
            })
                .then((res) => {
                    this.tkForm.ydxss = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },
        //填充教师所在系部
        tkSzxb(paramMap) {
            this.$api.evaluateManage.questionnaireServer.tkSzxb({
                data: paramMap
            })
                .then((res) => {
                    if (this.tkjlType === 'gg' || this.tkjlType === 'zy') {
                        this.tkjlForm.deptName = res.data.data.comboName;
                        this.tkjlForm.deptCode = res.data.data.comboValue;
                    } else {
                        this.tkForm.szxbName = res.data.data.comboName;
                        this.tkForm.szxbCode = res.data.data.comboValue;
                    }
                }).catch((err) => {
                console.log(err);
            });
        },
        tkChangeDf(event, index) {
            this.tkForm.df.set(index, event);
            this.hjdf = 0
            for (var i = 0; i < this.tkArr.dfArr.length; i++) {
                if (this.tkForm.df.get(this.tkArr.dfArr[i]) !== undefined && this.tkForm.df.get(this.tkArr.dfArr[
                    i]) !== null && this.tkForm.df.get(this.tkArr.dfArr[i]) !== '') {
                    this.hjdf += parseInt(this.tkForm.df.get(this.tkArr.dfArr[i]))
                }
            }
        },
        //课程下拉框
        tkCourseCombo(paramMap) {
            this.$api.evaluateManage.questionnaireServer.tkCourseCombo({
                data: paramMap
            })
                .then((res) => {
                    this.tkComboData.course = res.data.data;
                }).catch((err) => {
                console.log(err);
            });
        },
        //打开详情
        openTkInfo(index) {
            this.dialogVisible.tkEvaluateInfo = true;
            this.tkEvaluateInfoIndex = index;
        },
        //提交
        submit(type) {
            if (type == "01" || type == "02") {

                this.$refs['pfForm'].validate((valid) => {
                    if (valid) {
                    } else {
                        return false;
                    }
                });
                this.laterSub = true
                this.changePageColor()
                let pjx;
                let tea;
                for (var i = 0; i < this.pfForm.pfArr.length; i++) {
                    tea = this.pfForm.pfArr[i].findIndex(item => {
                        return item == undefined
                    })

                    if (tea != -1) {
                        tea = i;
                        break;
                    }
                }
                if (tea != -1) {
                    this.pageNum.pageNumColumn = tea + 1;
                    this.pageNum.teaPageNum = tea + 1;

                    let ind;
                    ind = this.pfForm.pfArr[tea].findIndex(item => {
                        return item == undefined
                    })
                    let str = "divider" + ind
                    this.$refs['stuMainDialogScroll'].wrap.scrollTop = this.$refs['stuWindowRef']
                        .getElementsByClassName(
                            str)[0].getBoundingClientRect().top - this.$refs['stuWindowRef'].getElementsByClassName(
                        "divider" + 0)[0].getBoundingClientRect().top + this.$refs.stuRef.offsetHeight - this
                        .$refs.stuWindowRef.offsetHeight

                    this.$alert("需完成所有评教才能提交", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });

                } else {
                    confirmMsg('提交后无法修改,是否确定提交?', 'el-message-box-mobile').then(() => {
                        let sub = [];
                        for (var i = 0; i < this.dfArr.length; i++) {
                            for (var j = 0; j < this.dfArr[i].length; j++) {
                                sub.push(this.dfArr[i][j])
                            }
                        }

                        let formData = new FormData();
                        formData.append('type', this.queryQueForm.type);
                        formData.append('semesterCode', this.queryQueForm.semesterCode)
                        formData.append('cjr', this.user.userCode)
                        if (type == "01") {
                            formData.append('classCode', this.stuXzrTableData.class.comboValue)
                        }
                        formData.append('list', sub)


                        if (type == "01") {
                            this.$api.evaluateManage.questionnaireServer.subStuEvaluate({
                                data: formData
                            })
                                .then((res) => {
                                    let state = res.data.data;
                                    switch (state) {
                                        case 'Success':
                                            this.dialogVisible.stuEvaluate = false;
                                            this.finishedQue()
                                            showNotify('成功', '提交成功', 'success', 1500);
                                            break;
                                        default:
                                            showNotify('错误', '提交失败', 'error', 3000);
                                            break;
                                    }
                                }).catch((err) => {
                                console.log(err);
                            });

                        } else {
                            this.$api.evaluateManage.questionnaireServer.subXzrEvaluate({
                                data: formData
                            })
                                .then((res) => {
                                    let state = res.data.data;
                                    switch (state) {
                                        case 'Success':
                                            this.dialogVisible.xzrEvaluate = false;
                                            showNotify('成功', '提交成功', 'success', 1500);
                                            this.finishedQue()
                                            break;
                                        default:
                                            showNotify('错误', '提交失败', 'error', 3000);
                                            break;
                                    }
                                }).catch((err) => {
                                console.log(err);
                            });
                        }
                    });
                }
            } else if (type == "03") {
                let flag1 = false;
                let flag2 = false;
                this.$refs['tkFormS'].validate((valid) => {
                    if (valid) {
                        flag1 = true;
                    } else {
                        return false;
                    }
                });

                this.$refs['tkForm'].validate((valid) => {
                    if (valid) {
                        flag2 = true;
                    } else {
                        return false;
                    }
                });
                if (!flag1 || !flag2) {
                    this.$alert("需完成所有评教才能提交", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });
                }
                if (flag1 && flag2) {
                    confirmMsg('提交后无法修改,是否确定提交?', 'el-message-box-mobile').then(() => {
                        for (var i = 0; i < this.tkComboData.course.length; i++) {
                            if (this.tkComboData.course[i].comboValue === this.tkForm.courseCode) {
                                this.tkForm.courseName = this.tkComboData.course[i].comboName
                                break;
                            }
                        }

                        for (var i = 0; i < this.tkComboData.course.length; i++) {
                            if (this.tkComboData.course[i].comboValue === this.tkForm.courseCode) {
                                this.tkForm.courseCode = this.tkComboData.course[i].otherInfo
                                break;
                            }
                        }

                        for (var i = 0; i < this.tkComboData.teaName.length; i++) {
                            if (this.tkComboData.teaName[i].comboValue === this.tkForm.teaCode) {
                                this.tkForm.teaName = this.tkComboData.teaName[i].comboName
                                break;
                            }
                        }

                        this.tkForm.tksj = this.tkForm.sj + "@" + this.tkForm.jc

                        const paramMap = {
                            'DF': this.tkForm.df,
                            'JSBH': this.tkForm.teaCode,
                            'JSXM': this.tkForm.teaName,
                            'JSLX': this.tkForm.teaType,
                            'JSXBDM': this.tkForm.szxbCode,
                            'JSXBMC': this.tkForm.szxbName,
                            'KCDM': this.tkForm.courseCode,
                            'KCMC': this.tkForm.courseName,
                            'TKKCLX': this.tkForm.courseType,
                            'TKBJBH': this.tkForm.tkbjCode,
                            'TKBJMC': this.tkForm.tkbjName,
                            'TKDD': this.tkForm.tkdd,
                            'TKSJ': this.tkForm.tksj,
                            'YDXSS': this.tkForm.ydxss,
                            'SDXSS': this.tkForm.sdxss,
                            'CDXSS': this.tkForm.cdxss,
                            'ZHPJJY': this.tkForm.zhpjjy,
                            'JXNRGC': this.tkForm.jxgcnr,
                            'RQ': this.tkForm.rq,

                            'CJR': this.user.userCode,
                            'type': this.queryQueForm.type,
                            'semesterCode': this.queryQueForm.semesterCode,
                        }

                        this.$api.evaluateManage.questionnaireServer.subTkForm({
                            data: paramMap
                        })
                            .then((res) => {
                                let state = res.data.data;
                                switch (state) {
                                    case 'Success':
                                        this.dialogVisible.tkEvaluate = false;
                                        this.finishedQue()
                                        showNotify('成功', '提交成功', 'success', 1500);
                                        break;
                                    default:
                                        showNotify('错误', '提交失败', 'error', 3000);
                                        break;
                                }
                            }).catch((err) => {
                            console.log(err);
                        });
                    });

                } else {
                    return false;
                }
            } else if (type === 'tkjl') {
                this.$refs['tkjlForm'].validate((valid) => {
                    if (valid) {
                        confirmMsg('提交后无法修改,是否确定提交?', 'el-message-box-mobile').then(() => {

                            for (var i = 0; i < this.tkjlComboOption.tea.length; i++) {
                                if (this.tkjlComboOption.tea[i].comboValue === this.tkjlForm.teaCode) {
                                    this.tkjlForm.teaName = this.tkjlComboOption.tea[i].comboName
                                    break;
                                }
                            }

                            for (var i = 0; i < this.tkjlComboOption.course.length; i++) {
                                if (this.tkjlComboOption.course[i].comboValue === this.tkjlForm.courseCode) {
                                    this.tkjlForm.courseName = this.tkjlComboOption.course[i].courseName
                                    break;
                                }
                            }

                            for (var i = 0; i < this.tkjlComboOption.course.length; i++) {
                                if (this.tkjlComboOption.course[i].comboValue === this.tkjlForm.courseCode) {
                                    this.tkjlForm.courseCode = this.tkjlComboOption.course[i].otherInfo
                                    break;
                                }
                            }

                            const paramMap = {
                                'teaCode': this.tkjlForm.teaCode,
                                'teaName': this.tkjlForm.teaName,
                                'deptCode': this.tkjlForm.deptCode,
                                'deptName': this.tkjlForm.deptName,
                                'date': this.tkjlForm.date,
                                'time': this.tkjlForm.time.join(','),
                                'className': this.tkjlForm.className,
                                'classCode': this.tkjlForm.classCode,
                                'courseCode': this.tkjlForm.courseCode,
                                'courseName': this.tkjlForm.courseName,
                                'ydxss': this.tkjlForm.ydxss,
                                'assk': this.tkjlForm.assk === true ? "1" : "0",
                                'cd': this.tkjlForm.cd,
                                'tqxk': this.tkjlForm.tqxk,
                                'sdrs': this.tkjlForm.sdrs,
                                'cdrs': this.tkjlForm.cdrs,
                                'ztrs': this.tkjlForm.ztrs,
                                'cdzc': this.tkjlForm.cdzc,
                                'kt': this.tkjlForm.kt,
                                'skgcjl': this.tkjlForm.skgcjl,
                                'jxjy': this.tkjlForm.jxjy,
                                'pjdj': this.tkjlForm.pjdj,
                                'site': this.tkjlForm.site,
                                'CJR': this.user.userCode,
                                'type': this.queryQueForm.type,
                                'semesterCode': this.queryQueForm.semesterCode,
                            }

                            this.$api.evaluateManage.questionnaireServer.subTkGgForm({
                                data: paramMap
                            })
                                .then((res) => {
                                    let state = res.data.data;
                                    switch (state) {
                                        case 'success':
                                            this.dialogVisible.tkjlEvaluate = false;
                                            this.finishedQue()
                                            showNotify('成功', '提交成功', 'success', 1500);
                                            break;
                                        default:
                                            showNotify('错误', '提交失败', 'error', 3000);
                                            break;
                                    }
                                }).catch((err) => {
                                console.log(err);
                            });
                        });

                    } else {
                        return false;
                    }
                });
            }
        },
        //关闭听课表dialog
        closeTkjl() {
            if (this.$refs['tkjlForm'] !== undefined) {
                this.$refs['tkjlForm'].clearValidate();
                this.$refs['tkjlForm'].resetFields();
                this.tkjlForm.classCode = ''
                this.tkjlForm.className = ''
                this.tkjlForm.deptCode = ''
                this.tkjlForm.deptName = ''
                this.tkjlForm.ydxss = ''
            }
        },
        closeTkEvaluate() {
            if (this.$refs['tkForm'] !== undefined) {
                this.$refs['tkForm'].clearValidate();
                this.$refs['tkForm'].resetFields();
            }
            if (this.$refs['tkFormS'] !== undefined) {
                this.$refs['tkFormS'].clearValidate();
                this.$refs['tkFormS'].resetFields();
            }

            this.tkForm.dfArr = []
            this.tkArr.dfArr = []
        },
        /** 听课表 end */
        /** 详情 start */
        showDetailInfo(id, type) {
            if (type == "01") {
                //学生表
                this.$api.evaluateManage.questionnaireServer.openStuQue({
                    data: id
                })
                    .then((res) => {
                        this.stuQueData = res.data.data
                    }).catch((err) => {
                    console.log(err);
                });
                this.dialogVisible.queryStuEvaluate = true;
            } else if (type == "02") {
                //系主任表
                this.$api.evaluateManage.questionnaireServer.openXzrQue({
                    data: id
                })
                    .then((res) => {
                        this.xzrQueData = res.data.data
                    }).catch((err) => {
                    console.log(err);
                });
                this.dialogVisible.queryXzrEvaluate = true;
            } else if (type == "03") {
                //听课表
                this.$api.evaluateManage.questionnaireServer.openTkQue({
                    data: id
                })
                    .then((res) => {
                        this.tkQueData.hjdf = 0;

                        this.tkQueData.basicInfo = res.data.data.basicInfo
                        this.tkQueData.pjxInfo = res.data.data.pjxInfo
                        this.tkQueData.basicInfo.jxnrgc = this.tkQueData.basicInfo.jxnrgc.replace(/\n/g,'<br>');
                        this.tkQueData.basicInfo.zhpjjy = this.tkQueData.basicInfo.zhpjjy.replace(/\n/g,'<br>');
                        for (var i = 0; i < this.tkQueData.pjxInfo.length; i++) {
                            this.tkQueData.hjdf += parseInt(this.tkQueData.pjxInfo[i].pf);
                        }
                        for (var i = 0; i < this.tkQueData.pjxInfo.length; i++) {
                            this.tkQueData.pjxInfo[i].y = this.tkQueData.pjxInfo[i].y.replace("<br />|<br />",
                                "~")
                            this.tkQueData.pjxInfo[i].l = this.tkQueData.pjxInfo[i].l.replace("<br />|<br />",
                                "~")
                            this.tkQueData.pjxInfo[i].z = this.tkQueData.pjxInfo[i].z.replace("<br />|<br />",
                                "~")
                            this.tkQueData.pjxInfo[i].c = this.tkQueData.pjxInfo[i].c.replace("<br />", "")
                        }
                        this.dialogVisible.queryTkEvaluate = true;
                    }).catch((err) => {
                    console.log(err);
                });
            }else if(type === '04' || type === '05'){

                this.$api.evaluateManage.questionnaireServer.openTkGgZyQue({
                    data: id
                })
                    .then((res) => {
                        this.tkjlQueData = res.data.data
                        this.tkjlQueData.jxnrgc = this.tkjlQueData.jxnrgc.replace(/\n/g,'<br>');
                        this.tkjlQueData.zhpjjy = this.tkjlQueData.zhpjjy.replace(/\n/g,'<br>');
                        if(type === '04'){
                            this.tkjlTitle = '听课记录表（公共基础）'
                            this.ckzbTitle = '公共基础课程参考指标'
                        }

                        if(type === '05'){
                            this.tkjlTitle = '听课记录表（专业课程）'
                            this.ckzbTitle = '专业课程参考指标'
                        }
                        this.dialogVisible.queryTkjlEvaluate = true

                    }).catch((err) => {
                    console.log(err);
                });

            }
        },
        //打开听课表详情
        openQueTkInfo(index) {
            this.dialogVisible.queryTkEvaluateInfo = true;
            this.tkEvaluateInfoIndex = index;
        },
        /** 详情 end */





        /** 学生表 start */
        querystuXzrTableData() {
            //评价项数据
            this.$api.evaluateManage.questionnaireServer.pjxData({
                data: this.queryQueForm.type
            })
                .then((res) => {
                    this.stuXzrTableData.pjxData = res.data.data

                    //教师信息
                    let formData = new FormData();

                    formData.append('stuCode', this.user.userCode);
                    formData.append('semesterCode', this.queryQueForm.semesterCode)
                    this.$api.evaluateManage.questionnaireServer.stuTeaData({
                        data: formData
                    })
                        .then((res) => {
                            this.stuXzrTableData.teaData = res.data.data

                            var pf = [];
                            var qz = [];
                            var df = [];
                            for (var i = 0; i < this.stuXzrTableData.teaData.length; i++) {
                                pf[i] = [];
                                qz[i] = [];
                                df[i] = [];

                                for (var j = 0; j < this.stuXzrTableData.pjxData.length; j++) {
                                    pf[i][j] = undefined;
                                    df[i][j] = undefined;
                                    qz[i][j] = parseInt(this.stuXzrTableData.pjxData[j].qz);
                                }
                            }
                            this.pfForm.pfArr = pf;
                            this.qzArr = qz;
                            this.dfArr = df;
                            this.createDialogVisible = false;
                            this.dialogVisible.stuEvaluate = true
                        }).catch((err) => {
                        console.log(err);
                    });
                }).catch((err) => {
                console.log(err);
            });

            //班级名称
            this.$api.evaluateManage.questionnaireServer.class({
                data: this.user.userCode
            })
                .then((res) => {
                    this.stuXzrTableData.class = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },

        //打开已完成学生表评价项详情
        openQueStuInfo(index) {
            this.dialogVisible.queryStuEvaluateInfo = true;
            this.stuEvaluateInfoIndex = index;
        },
        closeStuXzrDialog() {
            this.pfForm.pfArr = [];
            this.qzArr = [];
            this.subArr = [];
            this.dfArr = [];
            this.laterSub = false;
        },
        /** 学生表 end */

        /** 系主任表 start */
        queryXzrTableData() {
            //评价项数据
            this.$api.evaluateManage.questionnaireServer.pjxData({
                data: this.queryQueForm.type
            })
                .then((res) => {
                    this.stuXzrTableData.pjxData = res.data.data

                    //教师信息
                    let formData = new FormData();

                    formData.append('xzrCode', this.user.userCode);
                    formData.append('semesterCode', this.queryQueForm.semesterCode)
                    this.$api.evaluateManage.questionnaireServer.xzrTeaData({
                        data: formData
                    })
                        .then((res) => {
                            if(res.data.data.length === 0){
                                this.$alert("当前学期没有可评教老师", "提示", {
                                    confirmButtonText: "确定",
                                    customClass: 'el-message-box-mobile',
                                });
                            }else {
                                this.stuXzrTableData.teaData = res.data.data

                                var pf = [];
                                var qz = [];
                                var df = [];

                                for (var i = 0; i < this.stuXzrTableData.teaData.length; i++) {
                                    pf[i] = [];
                                    qz[i] = [];
                                    df[i] = [];

                                    for (var j = 0; j < this.stuXzrTableData.pjxData.length; j++) {
                                        pf[i][j] = undefined;
                                        df[i][j] = undefined;
                                        qz[i][j] = parseInt(this.stuXzrTableData.pjxData[j].qz);
                                    }
                                }
                                this.pfForm.pfArr = pf;
                                this.qzArr = qz;
                                this.dfArr = df;
                                this.createDialogVisible = false;
                                this.dialogVisible.xzrEvaluate = true
                            }

                        }).catch((err) => {
                        console.log(err);
                    });
                }).catch((err) => {
                console.log(err);
            });
        },
        //判断是否为专任教师
        sfzr(row, column) {
            let pjxData = this.stuXzrTableData.pjxData[column]
            let teaState = this.stuXzrTableData.teaData[row]
            if (pjxData.qz.indexOf("教师") != -1) {
                if (teaState == '1') {
                    //专任教师
                    return parseInt(pjxData.zrjs);
                } else {
                    //非专任教师
                    return parseInt(pjxData.fzrjs);
                }
            }
            return parseInt(pjxData.qz);
        },
        //是否专任 - 权重
        sfzrQz(row, column) {
            let zr = this.stuXzrTableData.pjxData[column].qz.split(")<br />(")

            let teaState = this.stuXzrTableData.teaData[row]

            if (this.stuXzrTableData.pjxData[column].qz.indexOf("教师") != -1) {
                if (teaState == '1') {
                    //专任教师
                    return zr[0].replace("专任教师:", '');
                } else {
                    //非专任教师
                    return zr[1].replace("非专任教师:", '');
                }
            }
            return zr[0];
        },
        //是否专任 - 评分标准
        sfzrPfbz(row, column) {
            let zr = this.stuXzrTableData.pjxData[column].pfbzsm.split("<br>")
            let teaState = this.stuXzrTableData.teaData[row]
            if (this.stuXzrTableData.pjxData[column].pfbzsm.indexOf("教师") != -1) {
                if (teaState == '1') {
                    //专任教师
                    return zr[0].replace("专任教师：  ", '');
                } else {
                    //非专任教师
                    return zr[1].replace("非专任教师：  ", '');
                }
            }
            return zr[0];
        },
        //打开已完成学生表评价项详情
        openQueXzrInfo(index) {
            this.queryGenForm.jsxm == ''
            this.dialogVisible.queryXzrEvaluateInfo = true;
            this.xzrEvaluateInfoIndex = index;
        },
        /** 系主任表 end */

        /** 总览 start */
        backToMain() {
            this.tkComboOption.tkbbh = '';
            this.generalFlag = true;
            this.limit = 10;
            this.currentPage = 1;
            this.genTableData.length = 0;
            this.queryGenForm.pageNum = 1;
            this.queryGenForm.rowNum = 10;
            this.queryGenForm.xnxqbm = '';
            this.queryGenForm.jsbh = '';
            this.queryGenForm.jsxm = '';
        },
        openGeneral() {
            this.generalFlag = false;
            this.queryGenList();
        },
        handleFilter() {
            this.scrollToTop();
            this.genTableData.length = 0;
            this.currentPage = 1;
            this.queryGenList();
            this.dialogVisible.queryDialogVisible = false;
        },
        handleReset() {
            this.scrollToTop();
            this.limit = 10;
            this.currentPage = 1;
            this.genTableData.length = 0;
            this.queryGenForm.pageNum = 1;
            this.queryGenForm.rowNum = 10;
            this.queryGenForm.xnxqbm = '';
            this.queryGenForm.jsbh = '';
            this.queryGenForm.jsxm = '';
            this.tableLoading = false;
            this.dialogVisible.queryDialogVisible = false;
            this.queryGenList();
        },
        queryGenList() {
            this.tableLoading = true;
            this.queryGenForm.pageNum = this.currentPage;

            this.$api.evaluateManage.questionnaireServer.queryList({
                data: this.queryGenForm,
            }).then((res) => {
                this.genTableData = this.genTableData.concat(res.data.data.list);

                this.total = res.data.data.total;
                this.tableLoading = false;
            }).catch((err) => {
                console.log(err);
                this.tableLoading = false;
            });
        },
        handleScroll() {
            if (this.checkVisible() && !this.tableLoading && this.total > this.genTableData.length) {
                this.currentPage++;
                this.queryGenList();
            }
        },
        checkVisible() {
            const ele = document.getElementById('loadingTips');
            if (ele) {
                let rect = ele.getBoundingClientRect();
                //获取当前浏览器的视口高度，不包括工具栏和滚动条
                //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                //bottom top是相对于视口的左上角位置
                //bottom大于0或者top-视口高度小于0可见
                return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
            } else {
                return false;
            }
        },
        scrollToTop() {
            const ele = document.getElementById('listArea');
            if (ele) {
                ele.scrollTop = 0;
            }
        },
        handleEdit(jsxm, jsbh, xnxqbm) {
            this.genTitle = jsxm;
            this.dialogVisible.generalInfo = true

            this.paramMap.jsbh = jsbh;
            this.paramMap.xnxqbm = xnxqbm;

            this.$api.evaluateManage.questionnaireServer.details({
                data: this.paramMap
            }).then((res) => {
                this.detailsTable = res.data.data;
            }).catch((err) => {
                console.log(err);
            })
        },
        tkHandleEdit() {
            this.$api.evaluateManage.questionnaireServer.tkCombo({
                data: this.paramMap,
            }).then((res) => {
                this.tkComboOption.tkCombo = res.data.data
                this.tkComboOption.tkbbh = res.data.data[0].comboValue
                this.showDetailInfo(this.tkComboOption.tkbbh, '03')
            }).catch((err) => {
                console.log(err);
            });
            this.tkDialogVisible = true
        },
        /** 总览 end */

        //提交时如果为空,页码变红
        changePageColor() {
            let set = new Set();
            for (var i = 0; i < this.pfForm.pfArr.length; i++) {
                for (var j = 0; j < this.pfForm.pfArr[i].length; j++) {
                    if (this.pfForm.pfArr[i][j] == undefined) {
                        set.add(i)
                    }
                }
            }
            let arr = Array.from(set)

            let ind = arr.findIndex(item => {
                return item == this.pageNum.teaPageNum - 1
            })

            if (ind != -1) {
                this.$refs.pagin.$el.childNodes[1].getElementsByClassName("leftSpan")[0].style.color = 'red'
            } else {
                this.$refs.pagin.$el.childNodes[1].getElementsByClassName("leftSpan")[0].style.color = 'black'
            }
        },

        //修改评分
        changePf(event, row, column) {
            let pjxBh = this.stuXzrTableData.pjxData[column].bh;
            let teaCode = this.stuXzrTableData.teaData[row].teaCode;
            let courseName = this.stuXzrTableData.teaData[row].courseName;
            let courseCode = this.stuXzrTableData.teaData[row].courseCode;
            let qz = "";

            if (this.queryQueForm.type == "01") {
                qz = this.qzArr[row][column];
            } else {
                qz = this.sfzrQz(row, column);
            }
            this.dfArr[row][column] = pjxBh + "@" + teaCode + "@" + event + "@" + courseName + "@" + courseCode +
                "@" + qz;
            if (this.laterSub) {
                this.changePageColor()
            }
        },

        getTeaPageNum(val) {
            this.pageNum.teaPageNum = val;
            if (this.laterSub) {
                this.changePageColor(val)
            }

        },
        getPjxPageNum(val) {
            this.pageNum.pjxPageNum = val;
        },
        getSemesterName() {
            let ind = this.comboData.semester.findIndex(item => {
                return item.comboValue == this.queryQueForm.semesterCode
            })
            this.semesterName = this.comboData.semester[ind].comboName
        },

        rqFormat(dat) {
            //获取年月日，时间
            var year = dat.getFullYear();
            var mon = (dat.getMonth() + 1) < 10 ? "0" + (dat.getMonth() + 1) : dat.getMonth() + 1;
            var day = dat.getDate() < 10 ? "0" + (dat.getDate()) : dat.getDate();
            var hour = dat.getHours() < 10 ? "0" + (dat.getHours()) : dat.getHours();
            var min = dat.getMinutes() < 10 ? "0" + (dat.getMinutes()) : dat.getMinutes();
            var seon = dat.getSeconds() < 10 ? "0" + (dat.getSeconds()) : dat.getSeconds();

            var newDate = year + "-" + mon + "-" + day + " " + hour + ":" + min + ":" + seon;
            return newDate;
        },

        format(dat) {
            //获取年月日，时间
            var year = dat.getFullYear();
            var mon = (dat.getMonth() + 1) < 10 ? "0" + (dat.getMonth() + 1) : dat.getMonth() + 1;
            var day = dat.getDate() < 10 ? "0" + (dat.getDate()) : dat.getDate();

            var newDate = year + "-" + mon + "-" + day;
            return newDate;
        },

        //退出
        back() {
            confirmMsg('退出后数据不保存,是否确定退出?', 'el-message-box-mobile').then(() => {
                this.dialogVisible.tkEvaluate = false;
                this.dialogVisible.stuEvaluate = false;
                this.dialogVisible.xzrEvaluate = false;
                this.dialogVisible.tkGgEvaluate = false;
                this.dialogVisible.tkjlEvaluate = false;
                this.finishedQue()
            });
        },
    }
};
</script>
<style src="styles/mobile.css"></style>
<style scoped>
#mobileMode {
    line-height: 0;
}

#mobileMode .filter-container {
    padding: 0 1em 0.2em 1em;
}

#mobileMode #queryDialog {
    top: 150px;
}

#mobileMode .mainList {
    height: calc(100% - 150px) !important;
}

#mobileMode #mainDialogScroll {
    height: 65vh;
    padding: 10px 20px;
}

#mobileMode #tkMainDialogScroll {
    height: 75vh;
    padding: 10px 15px;
}

#mobileMode #pfMainDialogScroll {
    height: 50vh;
    padding: 10px 20px;
}

#mobileMode #pfInputDialogScroll {
    height: 5vh;
}


#mobileMode #xzrMainDialogScroll {
    height: 75vh;
    padding: 10px 20px;
}

#mobileMode #loadingTips {
    height: 30px;
    line-height: 30px;
    color: #9d9d9d;
    position: relative;
    bottom: 0;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// questionnaireServerMobile.vue?30b4d1f0